import { RootLayout } from '@/layouts';
import Router from './Router';

function App() {
	return (
		<RootLayout>
			<Router />
		</RootLayout>
	);
}

export default App;
